import { ChangeDetectionStrategy, Component } from '@angular/core';
import { AppService } from '@app/app.service';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['../styles/footer.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class FooterComponent {
    constructor(public appService: AppService) {
    }
}
